import React from 'react';
import ProfileMenu from './ProfileMenu';
import { FaBars } from 'react-icons/fa';
import './navigation.css';


const Header = ({ handleToggleSidebar,handleCollapsedChange,toggled,
    collapsed }) => {


    const marginLeft = (toggled==false || window.innerWidth<=768)?0:(collapsed==false?270:80);
    return (
        <div className="topbar hidethis modern-topbar">



            <nav className="navbar-custom modern-navbar d-flex justify-content-between align-items-center" style={{marginLeft: marginLeft,transition: 'all 0.3s '}}>
            <button type="button" aria-label="Alternar menu lateral" className="btn-toggle modern-menu-toggle" onClick={() => {
                    if(window.innerWidth<=768){
                        handleToggleSidebar(!toggled)

                    }
                    else{
                        handleCollapsedChange(!collapsed)

                    }
                }}>
                    <FaBars />
                </button>
                <ul className="navbar-right header-controls d-flex list-inline float-right mb-0">
                    <ProfileMenu />


                </ul>



            </nav>
        </div>

    );

}


export default Header;
